/* hs-eslint ignored failing-rules */

/* eslint-disable no-bitwise */
'use es6';
/*
 * Adds the code folds gutter to the CodeMirror editor.
 * Adds the following props:
 *   - onFold: PropTypes.func
 *   - onUnfold: PropTypes.func
 *
 * !! The following MUST be imported !!
 *   //= require codemirror/static-5.24/addon/fold/foldgutter.css
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import getComponentName from 'react-utils/getComponentName';
import { loadCodeMirrorCSS } from 'react-codemirror/util/LoadCSS';
import loadCSS from 'react-codemirror/decorator/_internal/loadCSS';
import 'codemirror/addon/fold/foldcode';
import 'codemirror/addon/fold/foldgutter';
import 'codemirror/addon/fold/brace-fold';
import 'codemirror/addon/fold/indent-fold';
import 'codemirror/addon/fold/xml-fold';
import 'codemirror/addon/fold/comment-fold';
import { compose } from '../util/miniUnderscore.js';
const withLoadCSS = loadCSS([loadCodeMirrorCSS('/addon/fold/foldgutter.css')]);
const GUTTER_ID = 'CodeMirror-foldgutter';
export default function foldGutter() {
  return function withFoldGutter(CodemirrorComponent) {
    /**
     * @class
     */
    class WithFoldGutter extends Component {
      constructor(props) {
        super(props);
        this.codemirror = null;
        this.refCodemirror = this.refCodemirror.bind(this);
        this.onFold = this.onFold.bind(this);
        this.onUnfold = this.onUnfold.bind(this);
      }

      componentWillUnmount() {
        this.unbindEvents();
      }

      codemirrorMounted(codemirror) {
        if (this.codemirror === codemirror) {
          return;
        }

        this.codemirror = codemirror;

        if (!this.codemirror) {
          return;
        }

        this.addFoldGutter();
        this.unbindEvents();
        this.bindEvents();
      }

      bindEvents(bind = true) {
        const method = bind ? 'on' : 'off';
        this.codemirror[method]('fold', this.onFold);
        this.codemirror[method]('unfold', this.onUnfold);
      }

      unbindEvents() {
        this.bindEvents(false);
      }

      addFoldGutter() {
        const {
          codemirror
        } = this;

        if (!codemirror) {
          return;
        }

        const gutters = codemirror.getOption('gutters');

        if (!~gutters.indexOf(GUTTER_ID)) {
          codemirror.setOption('gutters', [...gutters, GUTTER_ID]);
        } // HACK: Fixes issue where fold buttons sometimes don't initially appear.


        setTimeout(() => {
          if (!codemirror) {
            return;
          }

          if (codemirror.getOption('foldGutter') !== true) {
            codemirror.setOption('foldGutter', true);
          }
        }, 0);
      }

      onFold(codemirror, from, to) {
        if (!this.props.onFold) {
          return;
        }

        this.props.onFold({
          codemirror,
          from,
          to
        });
      }

      onUnfold(codemirror, from, to) {
        if (!this.props.onUnfold) {
          return;
        }

        this.props.onUnfold({
          codemirror,
          from,
          to
        });
      }

      refCodemirror(ref) {
        const codemirror = ref && ref.codemirror;
        this.codemirrorMounted(codemirror);

        if (this.props.refCodemirror) {
          this.props.refCodemirror(ref);
        }
      }

      render() {
        return /*#__PURE__*/_jsx(CodemirrorComponent, Object.assign({}, this.props, {
          refCodemirror: this.refCodemirror
        }));
      }

    }
    /*
     * Statics
     */


    WithFoldGutter.propTypes = {
      refCodemirror: PropTypes.func,

      /** @type {Function} Fires when code is folded. */
      onFold: PropTypes.func,

      /** @type {Function} Fires when code is unfolded. */
      onUnfold: PropTypes.func
    };
    WithFoldGutter.displayName = `WithFoldGutter(${getComponentName(CodemirrorComponent)})`;
    return compose(withLoadCSS)(WithFoldGutter);
  };
}